import React, { useState, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import BottomNav from "../feature/navigation/BottomNav";
import NewTransactionScreen from "../feature/transactions/screen/NewTransactionScreen";
import ReportScreen from "../feature/transactions/screen/ReportScreen";
import { createTheme, ThemeProvider } from "@mui/material";
import JournalScreen from "../feature/transactions/screen/JournalScreen";

const App = () => {
    const [darkMode, setDarkMode] = useState(true);

    const theme = useMemo(() =>
        createTheme({
            palette: {
                mode: darkMode ? "light" : "dark",
            },
        }), [darkMode]
    );

    const toggleDarkMode = useCallback(() => {
        setDarkMode((prevMode) => !prevMode);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/spa/transaction/*" element={<NewTransactionScreen />} />
                    <Route path="/spa/report/*" element={<ReportScreen />} />
                    <Route path="/spa/journal/*" element={<JournalScreen />} />
                    <Route path="/spa" element={<Navigate to="/spa/transaction" replace />} />
                    <Route path="*" element={<Navigate to="/spa/transaction" replace />} />
                </Routes>
                <BottomNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
            </Router>
        </ThemeProvider>
    );
};

export default App;